const geocodeCache = new Map();
const inflightRequests = new Map();

const buildQuery = (latitude, longitude) =>
  `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`;

export const geocodeKey = (latitude, longitude) => {
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return null;
  }
  return `${latitude.toFixed(5)},${longitude.toFixed(5)}`;
};

const formatDecodedAddress = (data) => {
  if (!data) {
    return "";
  }

  const address = data.address || {};
  const primary = address.road || address.highway || address.neighbourhood || address.suburb;
  const secondary =
    address.city || address.town || address.village || address.county || address.state || address.country;

  if (primary && secondary) {
    return `${primary} • ${secondary}`.toUpperCase();
  }

  if (primary) {
    return primary.toUpperCase();
  }

  if (data.display_name) {
    return data.display_name.toUpperCase();
  }

  return "";
};

export const getGeocodeLabel = (key) => {
  if (!key) {
    return undefined;
  }
  return geocodeCache.get(key);
};

export const getCachedGeocodeForCoords = (latitude, longitude) => {
  const key = geocodeKey(latitude, longitude);
  return key ? geocodeCache.get(key) : undefined;
};

export const reverseGeocodeLookup = (latitude, longitude) => {
  const key = geocodeKey(latitude, longitude);
  if (!key) {
    return Promise.resolve("");
  }

  if (geocodeCache.has(key)) {
    return Promise.resolve(geocodeCache.get(key));
  }

  if (inflightRequests.has(key)) {
    return inflightRequests.get(key);
  }

  if (typeof fetch === "undefined") {
    return Promise.resolve("");
  }

  const request = fetch(buildQuery(latitude, longitude), {
    headers: {
      Accept: "application/json",
      "User-Agent": "RangerWebDashboard/1.0",
    },
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      const formatted = formatDecodedAddress(data);
      if (formatted) {
        geocodeCache.set(key, formatted);
        return formatted;
      }
      return "";
    })
    .catch((error) => {
      console.error("Reverse geocode lookup failed", error);
      return "";
    })
    .finally(() => inflightRequests.delete(key));

  inflightRequests.set(key, request);
  return request;
};
